export enum CompanyStatusColor {
  'new' = 'purple',
  'active' = 'green',
  'delete' = 'red',
}

export enum CompanyDisplayName {
  companyName = 'Customer',
  displayName = 'Company', // (displayName);
  displayNameFull = 'Company (Display name)'
}
